import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useMediaQuery } from "@mui/material";
import { appTheme } from "shared/theme";

const theme = createTheme({
  palette: {
    // @ts-ignore
    neutral: {
      main: appTheme.palette.white?.main,
      contrastText: appTheme.palette.primary?.main,
    },
    green: {
      main: appTheme.palette.blue?.main,
      contrastText: appTheme.palette.white?.main,
    },
    other: {
      main: appTheme.palette.primary?.main,
      contrastText: appTheme.palette.white?.main,
    },
 roundButton: {
      main: "#addad9",
      contrastText: appTheme.palette.primary?.main,
    },
    yellow: {
      main: appTheme.palette.yellow?.main,
      contrastText: appTheme.palette.primary?.main,
    },
  },
});

export function CustomButtonContained({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <Button
        // @ts-ignore

        variant="contained"
      >
        {children}
      </Button>
    </ThemeProvider>
  );
}

export function CustomButtonContainedGreen({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <Button
        // @ts-ignore
        color="green"
        variant="contained"
      >
        {children}
      </Button>
    </ThemeProvider>
  );
}
export function CustomButtonText({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <Button
        // @ts-ignore
        color="other"
        variant="text"
      >
        {children}
      </Button>
    </ThemeProvider>
  );
}

export function CustomRoundButton({ children, ...props }) {
  const isMobile = useMediaQuery("(max-width: 770px)");
  const isLaptop = window.innerWidth < 2560 && window.innerWidth > 1030;
  return (
    <ThemeProvider theme={theme}>
      <Button // @ts-ignore
        color="roundButton"
        variant="contained"
        sx={{
          width: isLaptop || isMobile ? "60px" : "100px",
          height: isLaptop || isMobile ? "60px" : "100px",
          borderRadius: "50%",
        }}
        {...props}
      >
        {children}
      </Button>
    </ThemeProvider>
  );
}
